enum ActivityAlertLevel {
  None = 0,
  Normal = 1,
  Today = 2,
  Upcoming = 3,
  Urgent = 4,
  Tomorrow = 5
}

export default ActivityAlertLevel;
